import { Sparkles, TrendingUp, MapPin, Landmark, Flower, Volume2, Waves, Crown, Star, Heart, Users } from 'lucide-react';

interface BadgeProps {
  type: string;
  size?: 'sm' | 'md';
}

const BADGE_CONFIG: {
  [key: string]: {
    label: string;
    icon: typeof Sparkles;
    bgColor: string;
    textColor: string;
    borderColor: string;
  };
} = {
  'perle-rare': {
    label: 'Perle rare',
    icon: Sparkles,
    bgColor: 'bg-purple-50',
    textColor: 'text-purple-700',
    borderColor: 'border-purple-200',
  },
  'plus-reserve': {
    label: 'Parmi les plus réservé',
    icon: TrendingUp,
    bgColor: 'bg-orange-50',
    textColor: 'text-orange-700',
    borderColor: 'border-orange-200',
  },
  'emplacement-premium': {
    label: 'Emplacement premium',
    icon: MapPin,
    bgColor: 'bg-blue-50',
    textColor: 'text-blue-700',
    borderColor: 'border-blue-200',
  },
  'proche-monuments': {
    label: 'Proche des monuments',
    icon: Landmark,
    bgColor: 'bg-amber-50',
    textColor: 'text-amber-700',
    borderColor: 'border-amber-200',
  },
  'havre-paix': {
    label: 'Havre de paix',
    icon: Flower,
    bgColor: 'bg-green-50',
    textColor: 'text-green-700',
    borderColor: 'border-green-200',
  },
  'calme': {
    label: 'Calme',
    icon: Volume2,
    bgColor: 'bg-teal-50',
    textColor: 'text-teal-700',
    borderColor: 'border-teal-200',
  },
  'vue-mer': {
    label: 'Vue mer',
    icon: Waves,
    bgColor: 'bg-cyan-50',
    textColor: 'text-cyan-700',
    borderColor: 'border-cyan-200',
  },
  'luxe': {
    label: 'Luxe',
    icon: Crown,
    bgColor: 'bg-yellow-50',
    textColor: 'text-yellow-700',
    borderColor: 'border-yellow-200',
  },
  'nouveaute': {
    label: 'Nouveauté',
    icon: Star,
    bgColor: 'bg-pink-50',
    textColor: 'text-pink-700',
    borderColor: 'border-pink-200',
  },
  'coup-coeur': {
    label: 'Coup de cœur',
    icon: Heart,
    bgColor: 'bg-red-50',
    textColor: 'text-red-700',
    borderColor: 'border-red-200',
  },
  'romantique': {
    label: 'Romantique',
    icon: Heart,
    bgColor: 'bg-rose-50',
    textColor: 'text-rose-700',
    borderColor: 'border-rose-200',
  },
  'famille': {
    label: 'Famille',
    icon: Users,
    bgColor: 'bg-indigo-50',
    textColor: 'text-indigo-700',
    borderColor: 'border-indigo-200',
  },
};

export function Badge({ type, size = 'md' }: BadgeProps) {
  const config = BADGE_CONFIG[type];

  if (!config) return null;

  const Icon = config.icon;
  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs gap-1'
    : 'px-3 py-1 text-sm gap-1.5';
  const iconSize = size === 'sm' ? 12 : 14;

  return (
    <span
      className={`inline-flex items-center ${sizeClasses} rounded-full font-medium border ${config.bgColor} ${config.textColor} ${config.borderColor}`}
    >
      <Icon size={iconSize} />
      <span className="whitespace-nowrap">{config.label}</span>
    </span>
  );
}

export const AVAILABLE_BADGES = Object.keys(BADGE_CONFIG).map(key => ({
  value: key,
  label: BADGE_CONFIG[key].label,
}));
